import { render, staticRenderFns } from "./FatigueDriverAlarm.vue?vue&type=template&id=57fb34bf&scoped=true"
import script from "./FatigueDriverAlarm.vue?vue&type=script&lang=js"
export * from "./FatigueDriverAlarm.vue?vue&type=script&lang=js"
import style0 from "./FatigueDriverAlarm.vue?vue&type=style&index=0&id=57fb34bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb34bf",
  null
  
)

export default component.exports